import { ReportPageCmp, ReportPageProps } from "./types";
import { useEffect, useState } from "react";
import { getReportAPI } from "services/api/reports/api";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Breadcrumb } from "ui/components/Breadcrumb";
import { Loader } from "ui/components/Loader";
import { Routes } from "../../navigation";
import { REPORT_PAGE_TITLE } from "ui/components/PageTitle/consts";
import { useParams } from "react-router-dom";
import { Errors } from "services/forms/validation/types";
import { Report } from "services/api/reports/types";
import { ReportContent } from "./components/ReportContent";

const ReportPage: ReportPageCmp = (props: ReportPageProps) => {
  const { id } = useParams();

  const [report, setReport] = useState<Report>();
  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id) fetchReport(id);
  }, [id]);

  const fetchReport = async (id: string) => {
    if (id === undefined) {
      return;
    }

    setIsLoading(true);

    try {
      let result = await getReportAPI(id);

      setReport(result);
    } catch {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);

    setErrors({});
  };

  


  return (
    <>
      <div className=" ">
        <div className="bg-white rounded-t-md border border-b mb-2">
          <PageHeader>
            <PageTitle
              title={`${REPORT_PAGE_TITLE.text} - ${report?.name}`}
              icon={REPORT_PAGE_TITLE.icon}
              iconColor={REPORT_PAGE_TITLE.iconColor}
            />
            <Breadcrumb />
          </PageHeader>
        </div>

        {report && <ReportContent report={report} />}
      </div>
      <Loader isLoading={isLoading ?? false}> </Loader>
    </>
  );
};

ReportPage.route = Routes.ReportDetailPageRouter;

export default ReportPage;
